<script setup lang="ts">
  import { useAuthStore } from '@/stores/auth'

  const auth = useAuthStore()
</script>

<template>
  <div>
    <template v-if="auth.authenticated === 0">
      <div class="lg:bg-img-white-building fixed inset-0 bg-cover bg-no-repeat filter-brightness-50"></div>
      <div class="absolute inset-0 flex justify-center sm:items-center">
        <div class="relative max-h-screen max-w-96 w-full rounded-lg bg-white p-6 pt-14">
          <div class="absolute bottom-0 h-45 rounded-b-7.5 bg-cover max-lg:inset-x-0 lg:right-0 lg:w-90 -scale-x-100"></div>
          <!-- style="background-image: url('/images/auth/landscape.jpg')" -->
          <div class="flex justify-center">
            <img
              src="/images/auth/logo.png"
              class="w-48"
              alt="Logo">
          </div>
          <div class="isolate mt-12 pb-4">
            <app-router-view />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="postcss" scoped>
  @media (min-width: 1024px) {
    .lg\:bg-img-white-building {
      background-image: url('/images/auth/landscape.jpg');
    }
  }
</style>
